export const findWalks_en = {
  'create_a_walk' : 'Create a walk',
  'all_filtered_booked' : 'All walks that matched your filter are booked.',
  'no_walks_found' : 'Could not find any walks matching your filter.',

  'filter_walks' : 'Filter walks',
  'filter_where_label' : 'Where do you want to walk?',
  'filter_where_placeholder' : 'Enter position',
  'filter_where_position' : 'Use my position',
  'filter_radius_label' : 'Choose search radius',
  'filter_radius_placeholder' : 'Km from position',
  'filter_radius_help' : 'Standard: 10 km',
  'filter_when_label' : 'When do you want to walk?',
  'filter_when_placeholder' : 'Choose time',
  'filter_day_label' : 'Which day?',
  'filter_day_placeholder' : 'Choose day',
  'filter_button_text' : 'Filter walks',
  'filter_error_choose' : 'Choose one or more filters to start.',
  'clear_choice' : 'Clear choice',
  'clear_filter' : 'Clear filter',
  'my_position' : 'My position',
  'spot' : 'spot',
  'spots' : 'spots',

  'find_walks_error_header' : 'Could not get your position',
  'find_walks_error_message' : 'To see walks nearby, you have to allow geolocation.',
  'no_reviews' : 'No reviews yet',

  'place_error' : 'Could not find the place, please check your filter.',
  'position_error' : 'Could not find your position, but you can enter your position manually',
  'map_gps_error_header' : 'Could not show nearby walks',
  'map_gps_error_message' : 'To see walks near your position you need to allow geolocation'
}